import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { motion } from 'framer-motion';

import { ThemeUtilities } from '../../../theme';
import { Color, Mode, Size } from './types';

export const Progress = styled(motion.div)<{ color: Color; width: number }>`
  position: absolute;
  top: 0;
  left: 0;

  border-radius: inherit;
  height: 100%;
  transition: background-color 500ms ease-in;

  ${({ width }) =>
    css`
      width: ${width}%;
    `};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'ProgressBar', 'color'))};
`;

export const Container = styled.div<{ mode: Mode; size: Size }>`
  width: 100%;
  position: relative;
  overflow: hidden;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'ProgressBar', 'size'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'ProgressBar', 'mode'))};
`;
